import { Redirect } from 'react-router-dom';

import { PathsLayouts } from '../../config/routes';

export default function TuitionContinuityTariffAndTuition() {
  return <Redirect to={`${PathsLayouts.tariffAndTuiton}/tariff-continuity`} />;
}
